import { render, staticRenderFns } from "./CampaignInfo.vue?vue&type=template&id=5bab4973&scoped=true"
import script from "./CampaignInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CampaignInfo.vue?vue&type=style&index=0&id=5bab4973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bab4973",
  null
  
)

export default component.exports